import { render, staticRenderFns } from "./ShipmentBatchRemoveButton.vue?vue&type=template&id=3608dcad"
import script from "./ShipmentBatchRemoveButton.vue?vue&type=script&lang=js"
export * from "./ShipmentBatchRemoveButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports